<template>
  <div v-loading.fullscreen.lock="loading">
    <!--轮播图设置  -->
    <baseBreadcrumb :page="$t('message.rotograph')" :menu="$t('message.operationAndMaintenance')" />
    <section>
      <!-- 效果预览 -->
      <div class="footer">
        <div class="footerContainer">
          <!-- 效果预览 -->
          <div class="preview">{{ $t("message.resultspreview") }}</div>
          <div class="carousel">
            <el-carousel trigger="click" height="500px" :interval="play_time * 1000">
              <div v-for="(item, index) in carouselData" :key="index">
                <el-carousel-item v-if="item.status">
                  <a :href="item.location_url" target="_blank" v-if="item.location_url">
                    <img :src="item.pic_url" alt="" />
                  </a>
                  <img :src="item.pic_url" alt="" v-else />
                </el-carousel-item>
              </div>
            </el-carousel>
          </div>
        </div>
      </div>
      <!-- Banner配置 -->
      <div class="footer">
        <div class="footerContainer">
          <!-- 头部 -->
          <div class="head">
            <!-- Banner配置 -->
            <div class="fl">
              {{ $t("message.bannerConfiguration") }}
            </div>
            <!-- 滚动频率： -->
            <div class="fl">
              {{ $t("message.rollingFrequency") }}：<span>
                <el-input v-model="play_time" onfocus="this.select()" size="small"
                  :disabled="!isAuth(388)"></el-input></span>
              {{ $t("message.seconds") }}

            </div>
            <!-- 注释 -->
            <div class="fl zhu">
              <!-- 保存 -->
              <el-button type="primary" size="small" class="fr" @click="bannerPlayTimeSet" v-if="isAuth(388)">{{
                $t("message.save")
              }}</el-button>
            </div>
            <!-- 添加Banner -->
            <div class="fr">
              <el-button type="primary" size="small" @click="add">{{
                $t("message.addBanner")
              }}</el-button>
            </div>
          </div>
          <!-- 列表 -->
          <div class="table">
            <ol>
              <!-- 图片 -->
              <li>Banner</li>
              <!--  -->
              <li>排序</li>
              <li class="flex2">
                <el-popover placement="top" trigger="hover" content=" 配置了开始与结束时间的轮播图只在时间范围内展示。未配置开始时间与结束时间的为长期有效">
                  <i class="el-icon-question" slot="reference"></i>
                </el-popover>
                开始时间
              </li>
              <li class="flex2">结束时间</li>
              <!--  跳转链接-->
              <li class="flex3">
                {{ $t("message.skipLinks") }}
              </li>
              <!--说明  -->
              <li class="flex3">{{ $t("message.instructions") }}</li>
              <!-- 状态 -->
              <li>{{ $t("message.status") }}</li>
              <li></li>
            </ol>
            <vuedraggable class="wrapper" v-model="carouselData">
              <ul v-for="(item, index) in carouselData" :key="index">
                <li class="img" @click="getIndex(index)">
                  <el-upload :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="item.pic_url" :src="item.pic_url" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </li>

                <li>
                  {{ item.sort }}
                  <!-- <el-input v-model="item.sort" type="number"></el-input> -->
                </li>
                <li class="flex2"> <el-date-picker v-model="item.start_at" :placeholder="$t('message.startDate')"
                    type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker></li>
                <li class="flex2"> <el-date-picker v-model="item.end_at" :placeholder="$t('message.dateClosed')"
                    default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker></li>
                <li class="flex3">
                  <!-- 跳转链接 -->
                  <el-input v-model="item.location_url" :placeholder="$t('message.skipLinks')"
                    onfocus="this.select()"></el-input>
                </li>
                <!-- 说明 -->
                <li class="flex3">
                  <el-input v-model="item.remark" :placeholder="$t('message.instructions')"
                    onfocus="this.select()"></el-input>
                </li>
                <li>
                  <el-switch v-model="item.status"> </el-switch>
                </li>
                <li>
                  <!-- 删除 -->
                  <el-button type="danger" size="mini" @click="del(index)">
                    {{ $t("message.delete") }}</el-button>
                </li>
              </ul>
            </vuedraggable>
          </div>
          <!-- 保存 -->
          <div class="btn">
            <!--注：未保存，之前操作无效  -->
            <div class="fl zhu">{{ $t("message.carousel2") }}</div>
            <!-- 保存 -->
            <el-button type="primary" size="small" class="fr" @click="bannerSave" v-if="isAuth(387)">{{
              $t("message.save")
            }}</el-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import vuedraggable from "vuedraggable";
export default {
  data() {
    return {
      carouselData: [],
      index: 0,
      play_time: 0,
      loading: false,
    };
  },
  components: {
    vuedraggable,
  },
  created() {
    this.bannerList();
  },
  methods: {
    //   数据
    bannerList() {
      this.carouselData = [];
      this.$api.siteConfiguration.bannerList().then((res) => {
        this.carouselData = res.data;
        this.play_time = res.data[0].play_time;
      });
    },
    // 索引
    getIndex(index) {
      this.index = index;
    },
    // 图片格式
    beforeAvatarUpload(file) {
      this.loading = true;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        this.loading = false;
      }
      return isJPG || isPNG;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      if (file.code != 0) return this.$message.error(file.msg);
      this.carouselData[this.index].pic_url = file.data;

      this.loading = false;
      this.$forceUpdate();
    },
    // 添加
    add() {
      this.carouselData.push({
        location_url: "",
        pic_url: "",
        remark: "",
        status: true,
      });
    },
    // 删除
    del(i) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.delete"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.carouselData.splice(i, 1);
        })
        .catch(() => { });
    },
    // 保存
    bannerSave() {
      let flag = this.carouselData.every((item) => item.pic_url != "");
      if (!flag) return this.$message.error("未上传banner图");
      for (let i = 0; i < this.carouselData.length; i++) {
        if (this.carouselData[i].location_url) {
          if (this.carouselData[i].location_url.substr(0, 4) != "http") {
            this.$alert("请输入以http开头的链接", "提示", {
              confirmButtonText: "确定",
              center: true,
            });
            return;
          }
        }
      }

      let datas = {
        banner: this.carouselData,
      };
      this.$api.siteConfiguration.bannerSave(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.bannerList();
      });
    },
    //设置滚动频率
    bannerPlayTimeSet() {
      this.$api.siteConfiguration
        .bannerPlayTimeSet({ play_time: this.play_time })
        .then((res) => {
          this.$message.success(res.msg);
        });
    },
  },
};
</script>
<style lang='scss' scoped>
section {
  background-color: #f6f6f6;

  .header {
    padding: 20px;

    .headerContainer {
      padding: 20px;
      background-color: #fff;

      .operationContainer {
        display: flex;
        width: 100%;
        margin-top: 20px;

        .leftContainer {
          width: 60%;
          display: flex;

          .Container {
            width: 240px;
            margin-right: 20px;
          }
        }

        .rightContainer {
          width: 40%;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }

  .footer {
    .footerContainer {
      padding: 24px;
      background-color: #fff;
    }
  }
}

.preview {
  margin: 24px 24px 24px 0;
}

.carousel {
  width: 900px;

  img {
    width: 100%;
  }

  /deep/ .el-carousel__button {
    width: 15px;
    height: 15px;
    border-radius: 50%;
  }

  /deep/ .is-active .el-carousel__button {
    background-color: #036eb8;
    border-color: #036eb8;
  }
}

.head {
  height: 40px;
  line-height: 40px;
  margin-bottom: 30px;

  .fl {
    margin-right: 50px;

    span {
      display: inline-block;
      width: 100px;
    }
  }
}

.table {
  font-size: 14px;

  ol {
    display: flex;
    height: 56px;
    background-color: #eaeaea;
    color: #909399;
    font-weight: 600;
  }

  ul {
    display: flex;
    height: 90px;

    &:hover {
      background-color: #fdeacc;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
  }

  .flex3 {
    flex: 3;
    padding: 0 20px;
  }

  .flex2 {
    flex: 2;

    /deep/ .el-date-editor {
      width: 190px;

      .el-input__inner {
        padding-right: 0;
      }

    }
  }

  .img {
    position: relative;

    img {
      width: 100%;
      height: 49px;
    }

    input {
      width: 140px;
      height: 49px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      opacity: 0;
    }
  }
}

.btn {
  height: 40px;
  margin-top: 30px;
  border-top: 1px solid #ccc;
  padding-top: 20px;
}

.zhu {
  color: red;
  font-size: 12px;
}
</style>